import React, { ReactNode } from 'react';

type SwitchProps = {
    label?: string;
    value: boolean;
    name?: string;
    disabled?: boolean;
    className?: string;
    id?: string;
    renderLabel?: () => string | ReactNode;
    onChange(): void;
};

const Switch: React.FC<SwitchProps> = ({ label, renderLabel, onChange, value, name, disabled, className, id }) => (
    <div className={['switch-container', className].join(' ')}>
        <label className="switch">
            <input
                type="checkbox"
                name={name}
                onChange={onChange}
                checked={value}
                disabled={disabled || false}
                id={id || ""}
            />
            <span className="slider round"></span>
        </label>
        <div className="switch-text">{renderLabel ? renderLabel() : label}</div>
    </div>
);

export default Switch;
